// NOTE: URL query param that selects the active knowledge tab. Keeping the
// tab in the URL makes it deep-linkable — the knowledge-file-shared
// notification CTA points at `?tab=shared-with-me` so the recipient lands on
// the tab that actually holds the file (NSAI-2777).
export const KNOWLEDGE_TAB_PARAM = "tab" as const;
